import { Type } from 'class-transformer';

import { Question } from './question.model';

export class Source {
  @Type(() => Question)
  variables: Question[] = [];

  id: string;
  title: string;
  isSystem: boolean;
}

export type VariableRequiredType = 'UNIQUE' | 'REQUIRED' | 'OPTIONAL';
